<template>
    <div class="cloudTrailListSearch">
        <Form ref="cloudTrailListForm" :model="cloudTrailListForm" :label-width="75" :rules="ruleValidate">
            <Row :gutter="16">
                <Col span="7">
                    <FormItem :label="$t('CloudTrailSecurity.account')" prop="accountIdSearchKey" :label-width="70">
                        <Select v-model="cloudTrailListForm.accountIdSearchKey" filterable :transfer="true" @on-change="changeAccountId(cloudTrailListForm.accountIdSearchKey)" :placeholder="$t('alarms.common.pleaseSelectAccount')">
                            <Option v-for="item in accountIdList" :value="item.id" :key="item.id">{{ item.name}}</Option>
                        </Select>
                    </FormItem>
                </Col>
                <Col span="7">
                    <FormItem :label="$t('CloudTrailSecurity.region')" prop="regionSearchKey" :label-width="100">
                        <Select v-model="cloudTrailListForm.regionSearchKey" filterable :placeholder="$t('RAM.common.PleaseSelectRegion')" :transfer="true">
                            <Option :value="item.name" v-for="item in regionList" :key="item.id">{{item.name}}</Option>
                        </Select>
                    </FormItem>
                </Col>
            </Row>
            <Row :gutter="16">
                <Col span="7">
                    <FormItem :label="$t('CloudTrailSecurity.time')" prop="agentDate" :label-width="70">
                        <DatePicker :open="openPicker" format="yyyy-MM-dd HH:mm:ss" v-model="cloudTrailListForm.agentDate" type="datetimerange" :placeholder="$t('RAM.common.PleaseSelectTimeRange')" :transfer="true" :options="timeOptions" @on-change="handleChange" @on-open-change="openChange" @on-ok="handleOk" style="width: 100%;"></DatePicker>
                    </FormItem>
                 </Col>
                 <Col span="7">
                    <FormItem :label="$t('CloudTrailSecurity.caseName')" prop="eventNameSearchKey" :label-width="100">
                        <Select v-model="cloudTrailListForm.eventNameSearchKey" filterable :transfer="true" multiple :max-tag-count="1" @on-change="changeEventNameSearchKey(cloudTrailListForm.eventNameSearchKey)" :placeholder="$t('ActionTrailSecurity.pleaseSelectEventName')">
                            <Checkbox v-model="singleEventNameSearchKey" @on-change="selectEventNameSearchKeyAll" style="display: block;text-align:right;">{{ $t('alarms.common.all') }}</Checkbox>
                            <Option v-for="item in eventNameList" :value="item.awsEventName" :key="item.awsEventName">{{ item.awsEventName}}</Option>
                        </Select>
                    </FormItem>
                </Col>
                <Col span="4">
                    <Button type="primary" :loading="modal_loading"  @click="search('cloudTrailListForm')" v-hasPermission="['logs:cloudTrail:search']">{{ $t('CloudTrailSecurity.search') }}</Button>
                    <Button type="primary" :loading="loading" @click="exportList('cloudTrailListForm')" v-hasPermission="['logs:cloudTrail:export']">{{ $t('common.export') }}</Button>
                </Col>
            </Row>
        </Form>
    </div>
</template>
<script>
    import {setCookie,getCookie} from '../../../../../utils/cookieUtil.js'
    import TableCloudTrailList from '../cloudTrail_list/TableCloudTrailList'
    var tableCloudTrailList = TableCloudTrailList;
    export default {
        name: 'CloudTrailListSearch',
        data () {
            return {
                loading:false,
                startDate:'',
                endDate:'',
                timeList:'',
                openPicker:null,
                timeOptions: {},
                singleEventNameSearchKey:false,
                cloudTrailListForm: {
                    accountIdSearchKey:[],
                    regionSearchKey:'',
                    eventNameSearchKey:[],
                    agentDate:''
                },
                accountIdList:[], //账号
                regionList:[], //区域
                eventNameList:[],
                modal_loading:false,
                ruleValidate: {
                    accountIdSearchKey: [
                        { required: true, message: this.$t('alarms.common.pleaseSelectAccount'), trigger: 'change',type:'number'  }
                    ],

                    regionSearchKey: [
                        { required: true, message: this.$t('RAM.common.PleaseSelectRegion'), trigger: 'change' }
                    ],
                    agentDate: [{
                        type: 'array',
                        required: true,
                        message: this.$t("monitor.search.selectTimeRequired"),
                        fields: {
                            0: { required: true,  type: 'date',message: this.$t("monitor.search.selectTimeRequired"), trigger: 'change'},
                            1: { required: true,  type: 'date',message: this.$t('monitor.search.selectTimeRequired'), trigger: 'change'}
                        }
                    }],
                    eventNameSearchKey: [
                        {required: true, type: 'array', message: this.$t('monitor.search.selectEventNameRequired'), trigger: 'change'}
                    ]
                }
            }
        },
        mounted: function(){
            this.listAccountByCloudPlatformAndAreaType();
            this.queryCloudTrailSecurityEvents();
        },
        methods: {
            /**********************账号********************************/
            // 查询账号
            listAccountByCloudPlatformAndAreaType: function () {
                // 查询账号
                this.$api.account.listAccountByCloudPlatformAndAreaType({
                    "cloudPlatformType" : 0
                })
                .then(res => {
                    this.accountIdList = res.data;
                })
            },
            // 切换账号
            changeAccountId(val) {
                this.cloudTrailListForm.regionSearchKey='';
                //查询地区
                this.$api.account.queryAccountRegions("accountId",this.cloudTrailListForm.accountIdSearchKey)
                .then(res => {
                    this.regionList = res.data;
                })
            },
            /**********************事件名称********************************/
            queryCloudTrailSecurityEvents:function(){
                this.$api.cloudTrail.queryCloudTrailSecurityEvents("userName",getCookie(global.cookieName))
                .then(res => {
                    this.eventNameList = res.data;
                })
            },
            selectEventNameSearchKeyAll() {
                this.cloudTrailListForm.eventNameSearchKey = []
                if (this.singleEventNameSearchKey) {
                    this.eventNameList.map((item) => {
                        this.cloudTrailListForm.eventNameSearchKey.push(item.awsEventName)
                    })
                } else {
                    this.cloudTrailListForm.eventNameSearchKey = []
                }
            },
            // 切换事件名称
            changeEventNameSearchKey(val) {
                if (val.length === this.eventNameList.length&&val.length!=0) {
                    this.singleEventNameSearchKey = true
                } else {
                    this.singleEventNameSearchKey = false
                }
            },
            openChange(){
                this.openPicker=true;
                this.timeOptions={
                    disabledDate (date) {
                        let initdate = Date.now() - (getCookie(global.securityLogRetentionTime))*24*60*60*1000;
                        return (date && date.valueOf() < initdate) || (date && date.valueOf() >= new Date())
                    }
                }
            },
            handleOk(){
                if((this.endDate-this.startDate)<30*24*60*60*1000){
                    this.openPicker=false;
                }
                else{
                    alert(this.$t("monitor.search.timeIntervalExceedMonth"))
                    this.openPicker=true;
                }
            },
            // 时间验证
            handleChange (val) {
                if(val[0]==""&&val[1]==""){
                    this.startDate=0;
                    this.endDate=0;
                    this.openPicker=true;
                }
                else{
                    this.startDate=(new Date(val[0])).getTime();
                    this.endDate=(new Date(val[1])).getTime();
                    this.timeList = val;
                }
            },
            /**********************搜索********************************/
            search: function (name) {
                this.$refs[name].validate((valid) => {
                    if (valid) {
                        tableCloudTrailList.methods.showAll(this.cloudTrailListForm.accountIdSearchKey,this.cloudTrailListForm.regionSearchKey,this.cloudTrailListForm.eventNameSearchKey,this.timeList);
                    }
                })
            },
            /**********************导出********************************/
            exportList: function (name) {
                this.$refs[name].validate((valid) => {
                    if (valid) {
                        this.loading = true
                        this.$Message.loading({
                            duration: 0,
                            content: this.$t('common.exporting')
                        })

                        // 下载Excel 文件
                        this.$api.cloudTrail.exportCloudTrailSecurityEvents({
                            "accountId" : this.cloudTrailListForm.accountIdSearchKey,
                            "regionStr" : this.cloudTrailListForm.regionSearchKey,
                            "timeList": this.cloudTrailListForm.agentDate,
                            "eventNames": this.cloudTrailListForm.eventNameSearchKey
                        })
                        .then(res => {
                            let fileName = this.$t('monitor.cloudTrail.exportFileName')
                            let blob = new Blob([res.data], {type: 'application/x-xls'})
                            if (window.navigator.msSaveOrOpenBlob) {
                              navigator.msSaveBlob(blob, fileName);
                            } else {
                              var link = document.createElement('a');
                              link.href = window.URL.createObjectURL(blob);
                              link.download = fileName;
                              link.click();
                              window.URL.revokeObjectURL(link.href);
                            }
                            this.loading = false;
                            this.$Message.destroy();
                            this.$Message.success(this.$t('common.exportSuccess'));
                        })
                    }
                })
            }
        }
    }
</script>
<style scoped>
    .cloudTrailListSearch
    {
        height: 51px;
    }
    .title-label
    {
        margin-top: 8px;
    }
</style>



// WEBPACK FOOTER //
// src/components/monitor/logs/cloudTrail/cloudTrail_list/CloudTrailListSearch.vue